export const MENU_ITEM_TEST_ID = {
  price: 'card-item-price',
  image: 'image-test-id',
  unavailable: 'unavailable',
  giftCard: 'gift-card-item'
};

export const PREVIOUS_ORDER_CARD = {
  root: 'previous-order-card',
  heading: 'previous-order-heading',
  items: 'previous-order-item-list'
};

export const PREVIOUS_ORDER_SECTION = {
  title: 'previous-order-section-title',
  moreLink: 'previous-order-section-more-orders'
};
